<template>
  <body>
    <!-- Admin pages: clean layout, no site header/footer -->
    <div v-if="isAdminPage">
      <router-view></router-view>
    </div>

    <!-- Regular site layout -->
    <div v-else id="page" class="page">
      <header id="header" class="header">
        <div class="container header-menu">
          <div id="row">
            <div class="col-md-4 col-sm-3 logo-col">
              <h1 class="">
                <router-link to="/" class="logo-link">
                  <img class="img" alt="Grupo Babilonia logo" src="./assets/newlogo_smaller.png">
                </router-link>
              </h1>
            </div>
            <div class="col-md-8 col-sm-9 nav-col">
              <NavBar class="custom-navbar"/>
            </div>
          </div>
        </div>
      </header>

      <!-- Homepage: Show slider -->
      <div v-if="isHomePage" class="slider">
        <FlexSlider2 :images="imageList"/>
      </div>

      <!-- Subpages: Show page header -->
      <PageHeader v-else :title="pageTitle" :subtitle="pageSubtitle" />

      <main id="main" class="home-sections">
        <router-view></router-view>
      </main>

      <!-- Footer on all pages -->
      <SiteFooter />
    </div>
  </body>
</template>

<script>
import FlexSlider2 from "@/components/FlexSlider2.vue";
import NavBar from "./components/NavBar.vue";
import PageHeader from "./components/PageHeader.vue";
import SiteFooter from "./components/SiteFooter.vue";
import { trackPageView } from "@/utils/analytics.js";

export default {
  name: 'App',
  components: { FlexSlider2, NavBar, PageHeader, SiteFooter },
  data() {
    return {
      imageList: [
        {src: "Los_Descreidos_Afiche.jpeg'", alt: "Afiche"},
        {src: "Babilonia_Landing_Page_1.jpeg'", alt: "Constru 1"},
        {src: "Babilonia_Landing_Page_2.jpeg'", alt: "Constru 2"},
        {src: "Babilonia_Landing_Page_3.jpeg'", alt: "Constru 3"},
      ],
      // Page titles configuration
      pageTitles: {
        '/funcion/1': { title: 'El Quijote Popular', subtitle: 'Chile' },
        '/funcion/2': { title: '8 Espejos', subtitle: 'Uruguay' },
        '/funcion/3': { title: 'La Loca del Bequeló', subtitle: 'Uruguay' },
        '/funcion/4': { title: 'Ernesto Díaz & Fabián Severo', subtitle: 'Música' },
        '/funcion/5': { title: 'Buceo Invisible', subtitle: 'Música' },
        '/funcion/6': { title: 'Noche de Circo', subtitle: 'Circo' },
        '/funcion/7': { title: 'Tercer Fuerxa', subtitle: 'Danza' },
        '/funcion/8': { title: 'Por culpa de la E', subtitle: 'Teatro' },
        '/funcion/9': { title: 'Naipe Marcado Trío Tango', subtitle: 'Música' },
        '/funcion/10': { title: 'Orquesta Subtropical', subtitle: 'Uruguay' },
        '/funcion/11': { title: '8 Espejos', subtitle: 'Uruguay' },
        '/funcion/12': { title: '8 Espejos', subtitle: 'Uruguay' },
        '/funcion': { title: 'Próximas Funciones', subtitle: '' },
        '/el-grupo': { title: 'El Grupo', subtitle: 'Nuestra historia' },
        '/cartelera': { title: 'Cartelera', subtitle: 'Festival Arena y Barro' },
        '/agenda': { title: 'Agenda', subtitle: '' },
        '/talleres': { title: 'Talleres', subtitle: '' },
        '/talleres/festival': { title: 'Talleres Festival', subtitle: 'Arena y Barro' },
        '/talleres/anual': { title: 'Taller Anual', subtitle: '' },
        '/galeria': { title: 'Galería', subtitle: '' },
        '/obras': { title: 'Obras', subtitle: '' },
      }
    };
  },
  watch: {
    '$route'(to) {
      // Don't track admin pages
      if (!to.meta.isAdmin) {
        trackPageView(to.fullPath)
      }

      if (!to.hash && !to.meta.isAdmin) {
        this.$nextTick(() => {
          const header = document.getElementById('header')
          if (header) {
            header.scrollIntoView({ behavior: 'instant', block: 'start' })
          }
        })
      }
    }
  },
  mounted() {
    // Wait for router to resolve before tracking initial page load
    this.$router.isReady().then(() => {
      if (!this.$route.meta.isAdmin) {
        trackPageView(this.$route.fullPath)
      }
    })
  },
  computed: {
    isAdminPage() {
      return this.$route.meta.isAdmin === true;
    },
    isHomePage() {
      return this.$route.path === '/';
    },
    pageTitle() {
      const path = this.$route.path;
      // Check for exact match first
      if (this.pageTitles[path]) {
        return this.pageTitles[path].title;
      }
      // Check for partial match (e.g., /funcion/1 matches /funcion)
      for (const key of Object.keys(this.pageTitles)) {
        if (path.startsWith(key)) {
          return this.pageTitles[key].title;
        }
      }
      return 'Grupo Babilonia';
    },
    pageSubtitle() {
      const path = this.$route.path;
      if (this.pageTitles[path]) {
        return this.pageTitles[path].subtitle;
      }
      for (const key of Object.keys(this.pageTitles)) {
        if (path.startsWith(key)) {
          return this.pageTitles[key].subtitle;
        }
      }
      return '';
    }
  }
};
</script>

<style>
/* ===== YOUR CURRENT DESKTOP / GLOBAL (unchanged) ===== */
.widget-wrap{ padding: 80px 0 90px; }
.item-thumb{ position: relative; }
.header-menu{ margin-left: 0px !important; position: relative; overflow: visible; width: 100%; }
.container{ margin-left: auto; margin-right: auto; padding-left: 15px; padding-right: 15px; overflow: visible; width: 100%; max-width: 100%; }
#main.home-sections { padding: 0; }
.next-sesion{ width: 300px; height: 300px; border-radius: 15px; }
.image-container { display: flex; width: 1320px; height: 330px; }
.image-item { flex: 1; height: 100%; }
.image-item img { width: 100%; height: 100%; object-fit: cover; }
.item{ position: relative; margin: 0 0 30px; }
.row{ margin-left: -15px; margin-right: -15px; }
.section-title{
  font-size: 45px; font-weight: 400; position: relative; text-transform: uppercase;
  margin: 0 0 50px; line-height: 1; letter-spacing: 0.18em; color: white;
}
.slider { position: relative; top: -160px; margin-bottom: -160px; background: none; }
.page{ background-color: black; }
.app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale;
  text-align: center; color: white; display: flex; justify-content: center; align-items: center;
  height: 100vh; margin: 0; margin-top: 100px;
}
.img { margin-left: 40px; }
.logo-link { display: inline-block; text-decoration: none; }
.mercado-pago{ width: 30%; border-radius: 50%; }
.content { margin-top: 450px; }
.header { height: 160px; padding: 22px 0; position: relative; z-index: 10; overflow: visible; }
.square-video { width: 600px; height: 600px; object-fit: contain; }
.titulo{ font-weight: bold; font-size: xx-large; padding-bottom: 30px; }

/* Desktop header layout */
#row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: visible;
  width: 100%;
}

.logo-col {
  flex: 0 0 auto !important;
  width: auto !important;
  max-width: none !important;
}

.nav-col {
  flex: 1 !important;
  display: flex !important;
  justify-content: flex-end !important;
  align-items: center !important;
  overflow: visible;
  position: relative;
  padding-right: 20px;
  max-width: none !important;
  width: auto !important;
  text-align: right;
}

.custom-navbar {
  overflow: visible;
  position: relative;
}

/* Desktop only - proper flexbox layout */
@media (min-width: 993px) {
  .header-menu {
    max-width: 100% !important;
    padding: 0 30px !important;
  }

  #row {
    display: flex !important;
    flex-direction: row !important;
    align-items: flex-start !important;
    justify-content: space-between !important;
    width: 100% !important;
  }

  .logo-col {
    position: relative !important;
    left: auto !important;
    transform: none !important;
    flex: 0 0 auto !important;
  }

  .nav-col {
    position: relative !important;
    right: auto !important;
    top: auto !important;
    left: auto !important;
    transform: none !important;
    width: auto !important;
    flex: 0 0 auto !important;
    padding-right: 0 !important;
    margin-left: auto !important;
    margin-top: 15px !important;
  }

  .custom-navbar {
    margin-left: auto;
  }
}

.header-menu {
  overflow: visible;
}

#navigation li { position: relative; z-index: 100; }
#navigation li.has-sub { overflow: visible; }

/* ===== TABLET (768px - 992px) ===== */
@media (min-width: 768px) and (max-width: 992px) {
  .header {
    height: 100px !important;
    padding: 15px 0 !important;
  }

  .slider {
    top: -100px !important;
    margin-bottom: -100px !important;
  }

  .img {
    margin-left: 10px !important;
    width: 80px !important;
    height: auto !important;
  }

  #row {
    display: flex !important;
    flex-direction: row !important;
    align-items: center !important;
    justify-content: space-between !important;
  }

  .logo-col {
    position: relative !important;
    left: auto !important;
    transform: none !important;
  }

  .nav-col {
    position: relative !important;
    right: auto !important;
    top: auto !important;
    left: auto !important;
    transform: none !important;
    padding-right: 15px !important;
    width: auto !important;
    flex: none !important;
  }

  /* Smaller nav buttons on tablet */
  #navigation li a {
    padding: 6px 8px !important;
    font-size: 13px !important;
  }

  #navigation li .toprow .toplink {
    padding: 6px 8px !important;
    font-size: 13px !important;
  }

  #navigation {
    gap: 6px !important;
  }
}

/* ===== MOBILE-ONLY OVERRIDES (below 768px) ===== */
@media (max-width: 767px) {
  /* Header row: hamburger left, logo center */
  #row {
    display: flex !important;
    flex-direction: row-reverse !important;
    align-items: center !important;
    justify-content: center !important;
    position: relative !important;
  }

  .logo-col {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }

  .nav-col {
    position: absolute !important;
    left: 10px !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
    right: auto !important;
    padding-right: 0 !important;
    justify-content: flex-start !important;
    width: auto !important;
    flex: none !important;
    text-align: left !important;
  }

  /* Compact header with smaller logo and top padding */
  .header {
    height: auto !important;
    padding: 75px 0 10px 0 !important;
  }
  .img { margin: 0 !important; width: 80px !important; height: auto !important; }

  /* NavBar wrapper */
  .custom-navbar {
    position: static !important;
    top: auto !important;
    right: auto !important;
    text-align: left !important;
  }

  /* Slider sits normally */
  .slider { top: 0; margin-bottom: 0; }

  /* Prevent sideways scroll */
  .container{ margin-left: auto; margin-right: auto; padding: 0 12px; }
  .row{ margin-left: 0; margin-right: 0; }

  /* Section title size */
  .section-title{ font-size: 28px; letter-spacing: .08em; margin-bottom: 28px; }

  /* Round images responsive */
  .image-thumb{ text-align: center; }
  .next-sesion{
    width: 70vw; max-width: 300px; height: auto;
    aspect-ratio: 1 / 1; border-radius: 15px;
  }

  /* Video responsive */
  .square-video{ width: 100%; height: auto; max-width: 600px; }
}

/* Tiny phones */
@media (max-width: 480px) {
  .next-sesion{ width: 80vw; }
}

/* Slider transparent + under the header */
.slider {
  background: transparent !important;
  position: relative;
  z-index: 1;
}
</style>